import * as React from 'react';
import { SortableElement } from 'react-sortable-hoc';
import IconService from '../../../../../Services/IconService';
import CarsGroupCell from '../carsGroupCell';

const AllCarsItem = SortableElement((thisItem: any) => (
  <div
    style={{
      borderBottom: '1px solid #cccccc',
      background: '#D2E2FD',
      paddingTop: '13px',
    }}
    key={`item-${thisItem.thisGroup}-${thisItem.item.vehicleId}`}
    id={`item-${thisItem.thisGroup}-${thisItem.item.vehicleId}`}
    className={`${thisItem.item.active} hover-off d-flex flex-row flex-wrap d-lg-table-row d-md-table-row`}
    draggable={true}
    data-cy={`item-${thisItem.item.vehicleId}`}
  >
    <div className="e-table-cell d-block d-lg-table-cell d-md-table-cell font-weight-bold px-2 text-nowrap col-10 col-md-auto order-2">
      <div
        title={thisItem.intl.formatMessage({
          id: `navigator.car.${
            thisItem.item.vehicleType === undefined ? 'car' : thisItem.item.vehicleType
          }`,
        })}
        style={{ marginRight: '15px' }}
      >
        <svg
          width="20px"
          height="20px"
          viewBox="10 5 30 30"
          version="1.1"
          className="rotate90"
          style={{
            float: 'left',
            marginRight: '10px',
            marginLeft: '-5px',
            position: 'relative',
            top: '4px',
          }}
        >
          <path
            id="path"
            d={IconService.getPath(thisItem.item.vehicleTypeId)}
            fill="#000"
            fillOpacity="1"
            stroke="none"
          />
        </svg>
        <CarsGroupCell
          name={thisItem.item.name}
          id={`name-${thisItem.thisGroup}-${thisItem.item.vehicleId}`}
          vehicleString={thisItem.vehicleString}
          isSeachable={true}
        />
      </div>
    </div>
    <div className="e-table-cell d-block d-lg-table-cell d-md-table-cell px-3 col-auto order-3">
      <CarsGroupCell
        name={thisItem.item.licenceNumber}
        id={`licence-${thisItem.thisGroup}-${thisItem.item.vehicleId}`}
        vehicleString={thisItem.vehicleString}
        isSeachable={true}
      />
    </div>
    <div className="e-table-cell d-block d-lg-table-cell d-md-table-cell px-2 col col-md-auto order-4">
      {thisItem.item.driverName && (
        <CarsGroupCell
          name={thisItem.item.driverName}
          id={`driver-${thisItem.thisGroup}-${thisItem.item.vehicleId}`}
          vehicleString={thisItem.vehicleString}
          isSeachable={true}
        />
      )}
    </div>
    <div className="e-table-cell d-block d-lg-table-cell d-md-table-cell px-3 col-auto order-5">
      <CarsGroupCell
        name={thisItem.item.customerName}
        id={`customer-${thisItem.thisGroup}-${thisItem.item.vehicleId}`}
        vehicleString={thisItem.vehicleString}
        isSeachable={true}
      />
    </div>
    <div
      className="d-block d-lg-table-cell d-md-table-cell px-1 text-center col-2 col-md-auto order-1 left-side"
      style={{ cursor: 'pointer' }}
    >
      <span
        title=""
        data-cy={`cars-group-arrow-unassigned-${thisItem.item.name}`}
        className="text-decoration-none text-gray"
      >
        <i className="cmd-icon cmd-icon-arrow-right-2 d-none d-md-inline-block" />
      </span>
    </div>
  </div>
));

export default AllCarsItem;
